'use client';

import { c as _c } from "react/compiler-runtime";
import type { GetPositionsRow, UserPortfolioSnapshotWire } from '@morfi/backend-sdk-v2/client';
import type { ConfirmedPositionTransition } from './confirmed-position-transitions';
import { useConfirmedPositionTransitions } from './use-confirmed-position-rows';
export interface PrizePoolHolding {
  readonly outcomeIndex: number;
  readonly claimRightsBalanceD6: string;
}
type IndexedHolding = Pick<GetPositionsRow, 'wallet' | 'market' | 'outcomeMint' | 'outcomeIndex' | 'claimRightsBalanceD6' | 'tradeCount'>;
export function usePrizePoolHoldings(args) {
  const $ = _c(4);
  const {
    transitions,
    snapshot
  } = useConfirmedPositionTransitions(args.userId);
  let t0;
  if ($[0] !== args || $[1] !== snapshot || $[2] !== transitions) {
    t0 = prizePoolHoldings({
      ...args,
      transitions,
      snapshot
    });
    $[0] = args;
    $[1] = snapshot;
    $[2] = transitions;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}

/** One row per owned wallet/mint; choose the latest execution before aggregating claim rights. */
export function prizePoolHoldings({
  wallets,
  market,
  indexedRows,
  snapshot,
  transitions
}: {
  readonly wallets: readonly string[];
  readonly market: string;
  readonly indexedRows: readonly IndexedHolding[];
  readonly snapshot: UserPortfolioSnapshotWire | null;
  readonly transitions: readonly ConfirmedPositionTransition[];
}): readonly PrizePoolHolding[] {
  const selected = new Map<string, IndexedHolding>();
  const owned = new Set(wallets);
  for (const row of [...indexedRows, ...(snapshot?.positions ?? []), ...transitions.map(({
    row
  }) => row)]) {
    if (row.market !== market || !owned.has(row.wallet)) continue;
    const identity = `${row.wallet}:${row.outcomeMint}`;
    const prior = selected.get(identity);
    if (prior === undefined || row.tradeCount > prior.tradeCount) selected.set(identity, row);
  }
  return [...selected.values()];
}